const API_TIMEOUT = 15000;

export async function api<T>(
  url: string,
  options?: RequestInit
): Promise<T> {
  const controller = new AbortController();

  const timeout = setTimeout(() => {
    controller.abort();
  }, API_TIMEOUT);

  try {
    const response = await fetch(url, {
      ...options,
      signal: controller.signal,
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(
        data?.message ?? "Request failed"
      );
    }

    return data;
  } finally {
    clearTimeout(timeout);
  }
}